import '@babel/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import history from 'utils/history';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { ThemeProvider } from 'styled-components';
import { lighten, darken } from 'polished';
import ReactNotification from 'react-notifications-component';

import 'sanitize.css/sanitize.css';
import './App.scss';
import 'react-notifications-component/dist/theme.css';

import App from 'containers/App';

//MSAL imports
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './auth-config';

export const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const MOUNT_NODE = document.getElementById('app');

const theme = {
  colors: {
    text: 'rgb(0,39,118)',
    base: '#fff',
    primary: '#384E77',
    transparent: 'transparent',
    secondary: '#f2f2f2',
    textDark: '#63636e',
    darkBase: '#fff',
    darkPrimary: '#0093E9',
    white: '#fff',
    black: '#000',
  },
  admin: {
    headerSize: '48px',
    sidebarSize: '245px',
    colors: {
      primary: '#6a197d',
      primaryLight: lighten(0.1, '#6a197d'),
      text: '#5f5f5f',
      textLight: lighten(0.25, '#5f5f5f'),
      textDark: darken(0.25, '#5f5f5f'),
      sideBar: 'rgb(247, 246, 243)',
    },
  },

  salmon: '#E8B082',
  bgU: '#2c2c2c',
  bgA: '#f2f2f2',
  primary: '#384E77',
  primaryLight: '#384E77',
  secondary: '#f2f2f2',
  indianRed: '#C26371',
  textBold: '#000000',
  textSubtitle: '#5B5B68',
  text: '#808B93',
  txt: 'red',
  red: '#041126',
  btnSecondary: '#dddddd',
  textMenu: '#BDBDCC',
  base: '#ffffff',
  error: '#FF0000',
  pdf: '#C42027',
  word: '#295495',
  sc: '#1BB53F',
};

const render = () => {
  ReactDOM.render(
    <>
      <ReactNotification />
      <DragDropContextProvider backend={HTML5Backend}>
        {/*<Router basename="/quellaveco" history={history}>*/}
        <Router basename="/chinalcop" history={history}>
          <ThemeProvider theme={theme}>
            <App instance={msalInstance}/>
          </ThemeProvider>
        </Router>
      </DragDropContextProvider>
    </>,
    MOUNT_NODE,
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}

render();
